import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "./PartnersSection.css"; // <-- on va y mettre notre CSS

const PartnersSection = () => {
  const [partners, setPartners] = useState([]);
  const navigate = useNavigate();
  const scrollRef = useRef(null);
const handleScroll = (dir) => {
    scrollRef.current.scrollBy({
      left: dir === "right" ? 300 : -300,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch("/partner", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) throw new Error("Erreur lors du chargement des partenaires");

        const data = await response.json();
        const actifs = data.filter(
          (p) => !p.deletedAt || p.deletedAt === null || p.deletedAt === ""
        );
        setPartners(actifs);
      } catch (error) {
        console.error(error);
      }
    };
    fetchPartners();
  }, []);

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  return (
    <div className="partners-section">
      <h2 className="title">Nos Partenaires</h2>
      <p className="subtitle">
        Leur engagement et leur soutien continu sont les piliers de notre succès commun.
      </p>
      

      <div className="logos-container">
        {partners.length > 0 && (
                <button className="arrow-btn left" onClick={() => handleScroll("left")}>
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>
              )}
        <div ref={scrollRef} className="logos-scroll">
          {partners.map((partner) => (
            <img
              key={partner.id}
              src={`/${partner.logo}`}
              alt={partner.name}
              className="partner-logo"
            />
          ))}
        </div>
         {partners.length > 0 && (
                  <button className="arrow-btn right" onClick={() => handleScroll("right")}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                )}
      </div>

      <div className="button-container">
        <button
          onClick={() => navigate("/admin/partners")}
          className="manage-button"
        >
          Gérer les partenaires
        </button>
      </div>
    </div>
  );
};

export default PartnersSection;
